import React from 'react';
import { Div, PanelHeader, PanelHeaderButton } from '@vkontakte/vkui';
import { pageContentClass } from '../../theme/classes';

export function AppShell({ children }) {
  return (
    <Div className={pageContentClass}>{children}</Div>
  );
}

export function ScreenHeader({ title, onBack }) {
  return (
    <PanelHeader
      before={onBack ? (
        <PanelHeaderButton aria-label="Назад" onClick={onBack}>
          <svg width="28" height="28" viewBox="0 0 28 28" fill="none" aria-hidden="true" className="block">
            <path
              d="M16.77 7.23a1 1 0 0 1 0 1.42L11.41 14l5.36 5.35a1 1 0 0 1-1.42 1.42l-6.06-6.06a1 1 0 0 1 0-1.42l6.06-6.06a1 1 0 0 1 1.42 0Z"
              fill="currentColor"
            />
          </svg>
        </PanelHeaderButton>
      ) : null}
    >
      {title}
    </PanelHeader>
  );
}
